import { PrivateWebinarMentor } from '@/dto'
import { MentorInitialState } from './types'

const state: MentorInitialState = {
  privateWebinarMentor: [] as PrivateWebinarMentor[],
}

export default state
